import Slider from "@material-ui/core/Slider";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import axios from "axios";
import { useCallback, useContext, useEffect, useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import Cropper from "react-easy-crop";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";

import { Link, useHistory } from "react-router-dom";
import swal from "sweetalert";
import { serverInfo, socketContext } from "../../App";
import noImage from "../../Assets/Images/settings/no-image.png";
import "../../components/CSS/Profile/profile.css";

import SkeletonArticle from "../../components/Post_skaliton/SkeletonArticle";
import LeftCardPhotos from "../../components/UserProfile/LaftCardPhotos";
import LeftCardVideos from "../../components/UserProfile/LaftCardVideos";

import Cover from "../../Assets/Images/Desert-Nights.jpg";
import UserInformation from "../../components/UserProfile/UserInformation";

import LuckySpinTryAgainModal from "../../components/CustomModal/LuckySpinTryAgainModal";

// import ImgDialog from './ImgDialog'
import { Button } from "@material-ui/core";
import getCroppedImg from "./cropImage";
import { styles } from "./styles";
import ProfileCard from "../../components/UserProfile/ProfileCard";
import DogWithBoll from "../../Assets/Images/dogwithball.gif";
import Navigation from "../../components/Layouts/Header/Navigation";
import useCoverChange from "../../CustomHooks/useCoverChange";
import useProfileChange from "../../CustomHooks/useProfileChange";
import {useI18n} from "../../i18n";

const dogImg =
  "https://img.huffingtonpost.com/asset/5ab4d4ac2000007d06eb2c56.jpeg?cache=sih0jwle4e&ops=1910_1000";

const Demo = ({ classes }) => {
  const { imageCdnUrl } = useContext(serverInfo);

  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [rotation, setRotation] = useState(0);
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  // const [croppedImage, setCroppedImage] = useState(null);

  const [profileCrop, setProfileCrop] = useState({ x: 0, y: 0 });
  // const [rotation, setRotation] = useState(0);
  const [profileZoom, setProfileZoom] = useState(1);
  const [profileCroppedAreaPixels, setProfileCroppedAreaPixels] =
    useState(null);

  const [infoBuffer, setInfoBuffer] = useState(false);
  const [coverBuffer, setCoverBuffer] = useState(false);
  const selectRef = useRef(null);


  // Cover Change
  const [croppedImage, setCroppedImage] = useState('');
  const [coverDelKey, setCoverDelKey] = useState(null);
  const [coverUrl, coverKey, coverProgress] = useCoverChange(croppedImage, 'profile/user/cover', coverDelKey);

  // Cover Change
  const [profileCroppedImage, setProfileCroppedImage] = useState('');
  const [profileDelKey, setProfileDelKey] = useState(null);
  const [profileUrl, profileKey, profileProgress] = useProfileChange(profileCroppedImage, 'profile/user/image', profileDelKey);



  const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  const profileOnCropComplete = useCallback(
    (croppedArea, croppedAreaPixels) => {
      setProfileCroppedAreaPixels(croppedAreaPixels);
    },
    []
  );
  const [noData, setNoData] = useState(false);
  const socketData = useContext(socketContext);
  const [messagenger, setMessenger] = useState(false);
  const history = useHistory();
  const [user, setUser] = useState([]);
  const [profileImage, setProfileImage] = useState("");
  const [profilePhotoUrl, setProfilePtotoUrl] = useState("");
  const [profilePhoto, setProfilePtoto] = useState("");
  const [coverPhoto, setCoverPhoto] = useState("");
  const [coverPhotoUrl, setCoverPhotoUrl] = useState("");
  const [coverImage, setCoverImage] = useState("");
  const [userActivites, setUserActivites] = useState([]);


  const [paginate, setPaginate] = useState(1);
  const [loader, setLoader] = useState(true);

  const [modalShow, setModalShow] = useState(false);
  const [profileModalShow, setProfileModalShow] = useState(false);
  const [giftCodeModal, setGiftCodeModal] = useState(false);
  const [giftData, setGiftData] = useState(null);
  const [giftTicketData, setGiftTicketData] = useState(false);
  const [ticketCodeModal, setTicketCodeModal] = useState(false);


  const handleClose = () => setModalShow(false);
  const handleShow = () => setModalShow(true);
  const handleProfileClose = () => setProfileModalShow(false);
  const handleProfileShow = () => setProfileModalShow(true);

  const { t } = useI18n();

  function handleClick() {
    setMessenger(!messagenger);
  }

  const logoutSubmit = (e) => {
    e.preventDefault();

    socketData.emit("logout", localStorage.getItem("auth_id"));

    axios.post(`/api/logout`).then((res) => {
      if (res.data.status === 200) {
        localStorage.removeItem("isLoggedIn");
        localStorage.removeItem("auth_token");
        localStorage.removeItem("auth_name");
        localStorage.removeItem("auth_id");
        localStorage.removeItem("auth_email");
        localStorage.removeItem("auth_phone");
        localStorage.removeItem("auth_image");

        swal("Success", res.data.message, "success");
        history.push("/login");
      } else {
        swal("Success", res.data.message, "success");
        history.push("/");
      }
    });
  };
  const fetchUserInfo = () => {
    localStorage.getItem("auth_token") &&
      axios.get(`/api/user_info`).then((res) => {
        if (res.status === 200) {
          setUser(res.data.users);
          setProfilePtotoUrl(
            res.data.users.image !== null
              ? res.data.users.image
              : noImage
          );
          setCoverPhotoUrl(
            res.data.users.cover_photo !== null
              ? res.data.users.cover_photo
              : noImage
          );
        }
      });
  }

  useEffect(() => {
    // setCoverDelKey(coverKey)
    fetchUserInfo();
  }, [coverDelKey, profileDelKey]);


  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    axios
      .get(`api/user/gift/item`)
      .then((res) => {
        setGiftData(res.data.data);
      })
      .catch(error => {
        console.error('Error fetching gift data:', error);
      });
  }, []);

  useEffect(() => {
    axios
      .get(`api/user/ticket`)
      .then((res) => {
        if(res.data.status === 404){
          setGiftTicketData(false);
        }else{
          setGiftTicketData(true);
        }
      })
      .catch(error => {
        console.error('Error fetching gift data:', error);
      });
  }, []);

console.log('giftTicketData', giftTicketData)

  const showCroppedImage = useCallback(async () => {
    try {
      const croppedImage = await getCroppedImg(
        coverPhoto,
        croppedAreaPixels,
        rotation
      );
      setCroppedImage(croppedImage);
      setModalShow(false);
    } catch (e) {
      console.error(e);
    }
  }, [coverPhoto, croppedAreaPixels, rotation]);

  const profileShowCroppedImage = useCallback(async () => {
    try {
      const profileCroppedImage = await getCroppedImg(
        profileImage,
        profileCroppedAreaPixels
      );
      setProfileCroppedImage(profileCroppedImage);
      setProfileModalShow(false);
    } catch (e) {
      console.error(e);
    }
  }, [profileImage, profileCroppedAreaPixels]);

  // const userData = await axios.get("api/user/gift/item");
  const fetchData = () => {
    axios
      // .get(`/api/user/activitiesData/with-paginate/5?page=${paginate}`)
      .get(`api/user/activitiesData`)
      .then((res) => {
        setLoader(false);
        if (res.status === 200) {
          // setUserActivites([...userActivites, ...res.data.userActivites?.data]);
          setUserActivites([...userActivites, ...res.data?.userActivites]);

          // setPaginate(paginate + 1);
          if (res.data.userActivites?.length === 0) {
            setNoData(true);
          }
        }
      });
  };


  useEffect(() => { }, [userActivites]);
  const fileRef = useRef();
  const filePro = useRef();

  const handleCoverChange = (e) => {
    setCoverImage(e.target.files[0]);
    setCoverPhoto(URL.createObjectURL(e.target.files[0]));
  };

  const handleProfileChange = (e) => {
    setProfilePtoto(e.target.files[0]);
    setProfileImage(URL.createObjectURL(e.target.files[0]));
  };

  const coverSave = () => {

    const fData = new FormData();
    fData.append("coverImage", coverKey);
    setCoverBuffer(true);
    axios.post(`/api/user/coverUpdate`, fData).then((res) => {
      setCoverBuffer(false);
      if (res.data.status === 200) {
        setCoverImage('')
        setCroppedImage('');
        setCoverDelKey(user?.cover_photo)
      }
    });
  };


  const profileSave = () => {
    const fData = new FormData();
    fData.append("profilePhoto", profileKey);
    setInfoBuffer(true);
    axios.post(`/api/user/profileUpdate`, fData).then((res) => {
      setInfoBuffer(false);
      if (res.data.status === 200) {
        setProfilePtoto('')
        setProfileCroppedImage('');
        setProfileDelKey(user?.image);
      }
    });
  };

  
  const productName = giftData?.details
  ? giftData.details.match(/Product Name: ([^\n<]+)/)?.[1]  // Extracts text after "Product Name: " and stops at newline or "<"
  : '';



  return (
    <>
      <Navigation />
      <div className="full-container py-3 ">
        <div className="d-flex justify-content-end rounded-3"></div>
        <div className="container mb-2">
          <div className="profile-img-cover ">
            <div className="profile-container">
              {croppedImage || coverPhotoUrl ? (
                <img
                  src={croppedImage ? croppedImage : imageCdnUrl + coverPhotoUrl}
                  className="img-fluid profile-cover"
                  alt="cover_photo"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = Cover;
                  }}
                />
              ) : (
                <img
                  src={Cover}
                  className="img-fluid profile-cover"
                  alt="cover_photo"
                />
              )}

              <div>
                {coverImage ? (
                  <button className="cover-po mx-5" onClick={coverSave}>
                    {coverBuffer ? (
                      <>
                        <i className="fas fa-spinner fa-pulse"></i>&nbsp;
                      </>
                    ) : (
                      <>
                        <i className="far fa-save mx-1"></i>
                      </>
                    )}
                    {t('Save_Text')}
                  </button>
                ) : null}

                <button className="bottomright" onClick={handleShow}>
                  <i className="fa-solid fa-camera"></i>
                </button>
              </div>
            </div>
          </div>

          <Modal
            show={modalShow}
            onHide={handleClose}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
          >
            <Modal.Body>
              <div>
                <div className={classes.cropContainer}>
                  <Cropper
                    image={coverPhoto}
                    crop={crop}
                    rotation={rotation}
                    zoom={zoom}
                    aspect={9 / 3}
                    onCropChange={setCrop}
                    onRotationChange={setRotation}
                    onCropComplete={onCropComplete}
                    onZoomChange={setZoom}
                  />
                </div>
                <div className={classes.controls}>
                  <div className={classes.sliderContainer}>
                    <Typography
                      variant="overline"
                      classes={{ root: classes.sliderLabel }}
                    >
                       {t('Zoom_Text')}
                    </Typography>
                    <Slider
                      value={zoom}
                      min={1}
                      max={3}
                      step={0.1}
                      aria-labelledby="Zoom"
                      classes={{ root: classes.slider }}
                      onChange={(e, zoom) => setZoom(zoom)}
                    />
                  </div>

                  <input
                    accept="image/*"
                    ref={fileRef}
                    onChange={handleCoverChange}
                    multiple={false}
                    type="file"
                    hidden
                  />
                  <div className="row">
                    <div className="col-md-6">
                  <Button
                    onClick={showCroppedImage}
                    variant="contained"
                    color="primary"
                    // classes={{ root: classes.cropButton }}
                  >
                     {t('Save_Text')}
                  </Button>
                    </div>

                    <div className="col-md-6">
                  <Button
                    onClick={() => fileRef.current.click()}
                    variant="contained"
                    color="primary"
                    // classes={{ root: classes.cropButton }}
                  >
                     {t('Choose_Text')}
                  </Button>
                    </div>
                  </div>
                </div>
              </div>
            </Modal.Body>
          </Modal>

          <div className="profile-div mb-5">
            <div className="profile-photo">
              <div className="d-flex justify-content-center">
                {profileCroppedImage || profilePhotoUrl ? (
                  <img
                    src={profileCroppedImage ? profileCroppedImage : imageCdnUrl + profilePhotoUrl}
                    alt=""
                    className="img-fluid profile-img"
                  />
                ) : (
                  <img
                    src={profileImage}
                    alt=""
                    className="img-fluid profile-img"
                  />
                )}
              </div>

              <button
                className="profile-pic-cam cam-po"
                onClick={handleProfileShow}
              >
                <i className="fa-solid fa-camera"></i>
              </button>

              <div>
                {profilePhoto ? (
                  <button
                    className="profile-pic-save cam-po px-3 py-1  "
                    onClick={profileSave}
                  >
                    {" "}
                    {infoBuffer ? (
                      <>
                        <i className="fas fa-spinner fa-pulse"></i>&nbsp;
                      </>
                    ) : (
                      <></>
                    )}
                    {t('Save_Text')}
                  </button>
                ) : null}
              </div>
              <div className="prodile-pic-info text-center mt-3 ">
                <h5 className="profile-font-color-head">
                  {user.first_name} {user.last_name}
                </h5>
                {user.username ? (
                  <small className="text-warning star-profile-type">
                    @{user.username}
                  </small>
                ) : (
                  <small className="text-warning star-profile-type">
                    @username  
                  </small>
                )}
              </div>
            </div>
          </div>

          <Modal
            show={profileModalShow}
            onHide={handleProfileClose}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
          >
            <Modal.Body>
              <div>
                <div className={classes.cropContainer}>
                  <Cropper
                    image={profileImage}
                    crop={profileCrop}
                    // rotation={rotation}
                    zoom={profileZoom}
                    aspect={1}
                    onCropChange={setProfileCrop}
                    // onRotationChange={setRotation}
                    onCropComplete={profileOnCropComplete}
                    onZoomChange={setProfileZoom}
                  />
                </div>
                
                <div className={classes.controls}>
                  <div className={classes.sliderContainer}>
                    <Typography
                      variant="overline"
                      classes={{ root: classes.sliderLabel }}
                    >
                        {t('Zoom_Text')}
                    </Typography>
                    <Slider
                      value={profileZoom}
                      min={1}
                      max={3}
                      step={0.1}
                      aria-labelledby="Zoom"
                      classes={{ root: classes.slider }}
                      onChange={(e, profileZoom) => setProfileZoom(profileZoom)}
                    />
                  </div>
                  <input
                    accept="image/*"
                    ref={filePro}
                    onChange={handleProfileChange}
                    multiple={false}
                    type="file"
                    hidden
                  />
                  <div className="row">
                    <div className="col-md-6">
                      <Button
                          onClick={profileShowCroppedImage}
                          variant="contained"
                          color="primary"
                          // classes={{ root: classes.cropButton }}
                      >
                          {t('Save_Text')}
                      </Button>
                    </div>
                    <div className="col-md-6">
                      <Button
                          // onClick={uploadImage}
                          // onClick={() => ref.current.click()}
                          onClick={() => filePro.current.click()}
                          variant="contained"
                          color="primary"
                          // classes={{ root: classes.cropButton }}
                      >
                       {t('Choose_Text')}
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </Modal.Body>
            {/* <Modal.Footer>
              <Button onClick={handleClose}>Close</Button>
            </Modal.Footer> */}
          </Modal>

          <div className="container main-div">
            <div className="row">
              <div className="col-md-5 user-left-top-margin">
                <div className="leftSide-user-sticky">
                  <div className="leftSide-user-sticky-scroll">
                    {user ? <UserInformation userInfo={user} /> : ""}

                    {/*<LeftCardPhotos*/}
                    {/*  title="Photos"*/}
                    {/*  photos={userActivites}*/}
                    {/*/>*/}


                    {/*<div className="mt-3">*/}
                    {/*  <LeftCardVideos*/}
                    {/*    title="Videos"*/}
                    {/*    videos={userActivites}*/}
                    {/*  />*/}
                    {/*</div>*/}
                    {/* <div className="container left-col-box p-3 mt-3">
                      <div className="accordion" id="accordionExample">
                        <div className="accordion-item mt-1 left-bottom-accorion">
                          <h2 className="accordion-header" id="headingTwo">
                            <p
                              className="accordion-button profile-accordion-button left-bottom-accorion collapsed"
                              type="button"
                            >
                              <span>
                                <i className="fa-solid fa-gift mx-2 profile-font-color fa-2x"></i>
                              </span>{" "}
                              <span className="mx-2 profile-font-color fw-bolder">
                                Gifts
                              </span>
                            </p>
                          </h2> 
                          {giftData && 
                          
                            <div className="mb-3">
                                <a
                                  href="javascript:void(0)"
                                  onClick={() => setGiftCodeModal(true)}
                                  className="fw-bolder fs-6"

                                >
                                  <i class="fa-solid fa-arrow-right me-4 profile-font-color ms-5"></i><span className="profile-font-color">Claim your {productName}</span>
                                </a>
                            </div>
                          }
                         
                         {giftTicketData &&
                          <div className="mb-3">
                            <a
                              href="javascript:void(0)"
                              onClick={() => setTicketCodeModal(true)}
                              className="fw-bolder fs-6"

                            >
                            <i class="fa-solid fa-arrow-right me-4 profile-font-color ms-5"></i><span className="profile-font-color">Claim your Ticket</span>
                            </a>
                          </div>
                         }

                         {!giftTicketData && !giftData &&
                         
                          <div className="mb-3">
                            <i class="fa-solid fa-arrow-right me-4 profile-font-color ms-5"></i><span className="profile-font-color">No Gifts</span>
                          </div>

                         }

                          
                        </div>
                      </div>
                    </div> */}
                    <div className="container left-col-box p-3 mt-3">
                      <div className="accordion" id="accordionExample">
                        <div className="accordion-item mt-1 left-bottom-accorion">
                          <h2 className="accordion-header" id="headingTwo">
                            <button
                              className="accordion-button profile-accordion-button left-bottom-accorion collapsed"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapseTwo"
                              aria-expanded="false"
                              aria-controls="collapseTwo"
                              onClick={logoutSubmit}
                            >
                              <span>
                                <i className="fas fa-sign-out-alt mx-2 profile-font-color fa-2x"></i>
                              </span>{" "}
                              <span className="mx-2 profile-font-color">
                                {t('Logout_Text')}
                              </span>
                            </button>
                          </h2>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-7 right-card-profile "></div>
              {/*<div className="col-md-7 right-card-profile ">*/}
              {/*  {loader &&*/}
              {/*    [1, 2, 3, 4].map(() => <SkeletonArticle theme="dark" />)}*/}

              {/*  {userActivites &&*/}
              {/*    userActivites.map((activity, index) => (*/}
              {/*      <ProfileCard*/}
              {/*        post={activity}*/}
              {/*        key={index}*/}
              {/*      />*/}
              {/*    ))}*/}
              {/*</div>*/}
            </div>
          </div>
        </div>

        {/* Messaging start */}
        {/* <div className="bottomleft-message d-flex ">
          <i
            onClick={handleClick}
            className="fab fa-facebook-messenger text-warning fa-4x bottomleft-icon"
          ></i>

          {messagenger ? (
            <div className="card mx-5 message-card">
              <div className="head m-0 p-2 d-flex justify-content-around align-items-center">
                <img
                  src={sakibal}
                  className="img-fluid rounded-circle"
                  height="40px"
                  width="40px"
                  alt=""
                />
                <span className="text-light fw-bold">Sakib Al Hasan</span>
                <i
                  className="fas fa-times-circle close-message text-light"
                  onClick={() => setMessenger(false)}
                ></i>
              </div>
              <div className="card-body">
                <img
                  src={sakibal}
                  className="img-fluid rounded-circle"
                  height="40px"
                  width="40px"
                  alt=""
                />
                <div className="d-flex">
                  <ReactPlayer
                    url="https://www.youtube.com/watch?v=3CaBNtaTrbo"
                    playing={false}
                    volume={1}
                    width="60%"
                  />
                  <i className="fas fa-share mx-2"></i>
                </div>
              </div>
            </div>
          ) : null}
        </div> */}
        {/* Messaging end */}

        <LuckySpinTryAgainModal
        sx={{
          backgroundColor: "#25272b",
          p: 3,
          py: 2,
          height: "32vH",
          overflow: "auto",
          width: { xs: "90%", sm: "31%" },
          color: "rgb(194, 194, 194)",
          zIndex: 200,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
        open={giftCodeModal}
      >
        <div
          style={{
            textAlign: "center",
          }}
        >
          <div
            style={{
              right: 15,
              top: 15,
              position: "absolute",
            }}
          >
            <a
              href="javascript:void(0)"
              onClick={() => setGiftCodeModal(false)}
            >
              <FontAwesomeIcon icon={faTimes} style={{ fontSize: 25 }} />
            </a>
          </div>
          <div
            style={{
              marginTop: "10px",
            }}
          >
          <div className="text-center">
            <span style={{fontSize: "25px"}}>Please submit this code</span> <br />
            <span><strong style={{fontSize: "35px"}}>{giftData?.reference_number}</strong></span> <br />
            <span style={{fontSize: "25px"}}>to the dedicated booth during claiming your gift.</span> <br />
            <span style={{fontSize: "15px"}}>Location : 7021, DOHA, QATAR., Abu Hamour, Qatar.</span>
          </div>

          </div>
        </div>
      </LuckySpinTryAgainModal>

      <LuckySpinTryAgainModal
        sx={{
          backgroundColor: "#25272b",
          p: 3,
          py: 2,
          height: "70vH",
          overflow: "auto",
          width: { xs: "90%", sm: "40%" },
          color: "rgb(194, 194, 194)",
          zIndex: 200,
          display: "flex",
          alignItems: "center",
        }}
        open={ticketCodeModal}
      >
        <div
          style={{
            textAlign: "center",
          }}
        >
          <div
            style={{
              right: 15,
              top: 15,
              position: "absolute",
            }}
          >
            <a
              href="javascript:void(0)"
              onClick={() => setTicketCodeModal(false)}
            >
              <FontAwesomeIcon icon={faTimes} style={{ fontSize: 25 }} />
            </a>
          </div>
          <div
            style={{
              marginTop: "10px",
            }}
          >
         <div className="text-left">
            <h1>Congratulations! You’ve won a free ticket!</h1>
            <div>
              Please{" "}
              <a
                className="fs-5"
                style={{ color: "yellow" }}
                href="https://play.google.com/store/apps/details?id=com.hellosuperstars"
                target="__blank"
              >
                download
              </a>{" "}
              our app Hello Superstar from the Play Store to receive your
              ticket.
            </div>
          </div>

          </div>
        </div>
      </LuckySpinTryAgainModal>

      </div>
    </>
  );
};

const Profile = withStyles(styles)(Demo);
export default Profile;
